import React from 'react';

function AngleRight(props: object) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.87514 2.42432L7.53805 3.08723L13.5671 9.11625C14.0553 9.60442 14.0553 10.3959 13.5671 10.884L7.53805 16.913L6.87514 17.576L5.54932 16.2502L6.21223 15.5873L11.7993 10.0001L6.21223 4.41305L5.54932 3.75014L6.87514 2.42432Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default AngleRight;
